import React, { useEffect } from "react";
import { View, StyleSheet, TouchableOpacity, ActivityIndicator } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";
import Text from "@components/AppText";
import colors from "@constants/color";
import { connect } from "react-redux";
import BankImage from "@assets/svg/WithdrawMoney/Bank";
import t from "@constants/localization";
import InputBox from "../../components/InputBox";
import { actions as walletActions } from "../../reducers/oldWalletReducer";
import { getIfscDetails, getWalletOtp } from "../../services/api";
import { STATE_STATUS } from "../../reducers/actionTypes";

const PATH = "screens/AddBankDetails/Content";

const ACCOUNT_TYPE = {
  bank_account: "bank_account",
  vpa: "vpa",
};

const WithdrawMoneyContent = ({
  navigation,
  wallet,
  fetchFundAccounts,
  resetFundAccountBank,
  createFundAccountBank,
  failedCreateFundAccountBank,
  params,
  user,
}) => {
  const [accountNo, setAccountNo] = React.useState(
    params && params.edit ? params.data?.account_number : null,
  );
  const [confirmAccountNo, setConfirmAccountNo] = React.useState(
    params && params.edit ? params.data?.account_number : null,
  );
  const [ifsc, setIfsc] = React.useState(
    params && params.edit ? params.data?.ifsc_code : null,
  );
  const [ifscDetails, setIfscDetails] = React.useState(null);
  const [accountName, setAccountName] = React.useState(
    params && params.edit ? params.data?.user_name : null,
  );
  const [upi, setUpi] = React.useState(
    params && params.edit ? params.data?.upi_address : null,
  );

  const [accountNoError, setAccountNoError] = React.useState(null);
  const [confirmAccountError, setConfirmAccountError] = React.useState(null);
  const [ifscError, setIfscError] = React.useState(null);
  const [ifscLoading, setIfscLoading] = React.useState(false);
  const [accountNameError, setAccountNameError] = React.useState(null);
  const [upiError, setUpiError] = React.useState(null);
  const [isNewAction, setIsNewAction] = React.useState(false);

  const IS_UPI = params && params.account_type === ACCOUNT_TYPE.vpa;
  const IS_EDIT = params && params.edit;
  const EDIT_DATA = params && params.data;

  const { phone_number = "", id = "", name = "" } = user || {};

  useEffect(() => {
    if (wallet.createFundAccountStatus === STATE_STATUS.CREATED) {
      navigation.navigate("WithdrawMoney");
      fetchFundAccounts();
      resetFundAccountBank();
    }
    if (wallet.createFundAccountStatus === STATE_STATUS.CREATE_FAILED) {
      const errors =
        wallet.createFundAccountError &&
        wallet.createFundAccountError.createAccountResult &&
        wallet.createFundAccountError.createAccountResult.errors;
      if (errors && errors.account_number) {
        setAccountNoError(errors.account_number.message);
      }
      if (errors && errors.ifsc) {
        setIfscError(errors.ifsc.message);
      }
      if (errors && errors.name) {
        setAccountNameError(errors.name.message);
      } else {
        if (
          wallet.createFundAccountError &&
          wallet.createFundAccountError.error &&
          wallet.createFundAccountError.error === "INVALID_OTP"
        ) {
          // do nothing
        } else {
          if (isNewAction) navigation.navigate("WithdrawMoney");
        }
      }
    }
  }, [wallet.createFundAccountStatus]);

  async function createAccount() {
    let error = false;
    // setIfscDetails(null);
    if (IS_UPI) {
      if (!upi) {
        setUpiError(t(`${PATH}/UPIRequired`));
        error = true;
      }
    } else {
      if (!accountNo) {
        setAccountNoError(t(`${PATH}/accNumberRequired`));
        error = true;
      }
      if (accountNo !== confirmAccountNo) {
        setConfirmAccountError(t(`${PATH}/accNoDoesNotMatch`));
        error = true;
      }
      if (!ifsc) {
        setIfscError(t(`${PATH}/IFSCCodeRequired`));
        error = true;
      }
      if (!accountName) {
        setAccountNameError(t(`${PATH}/bankNameRequired`));
        error = true;
      }
    }
    if (!error) {
      if (IS_UPI) {
        createFundAccountBank({
          account_type: ACCOUNT_TYPE.vpa,
          upi_address: upi,
        });
      } else {
        sendOtpToUser();
      }
    }
  }
  const sendOtpToUser = () => {
    const bankPayload = {
      account_type: ACCOUNT_TYPE.bank_account,
      ifsc,
      account_number: accountNo,
      name: accountName.replace(/\s\s+/g, " ").trim(),
    };
    getWalletOtp({ type: "create", isDebug: __DEV__, ...bankPayload })
      .then((res) => {
        setIsNewAction(true);
        navigation.navigate("VerifyAccount", {
          type: "create",
          item: {
            ...bankPayload,
          },
        });
      })
      .catch((error) => {
        if (error.response.data && error.response.data.errors) {
          const { errors } = error.response.data;
          if (errors && errors.account_number) {
            setAccountNoError(errors.account_number.message);
          }
          if (errors && errors.ifsc) {
            setIfscError(errors.ifsc.message);
          }
          if (errors && errors.name) {
            setAccountNameError(errors.name.message);
          }
        }
      });
  };

  async function validateIFSC(ifsc) {
    if (ifsc.length === 11) {
      try {
        setIfscLoading(true);
        const res = await getIfscDetails(ifsc);
        setIfscDetails(res.data);
        setIfscLoading(false);
      } catch (e) {
        setIfscDetails(false);
        setIfscLoading(false);
      }
    } else {
      setIfscDetails(null);
      setIfscLoading(false);
    }
  }

  function renderInputs(inputJson) {
    return inputJson.map(
      ({
        key,
        placeholder,
        maxLength,
        labelText,
        value,
        onChange,
        keyboardType,
        validator,
        error,
      }) => {
        return (
          <View
            style={{
              marginBottom: 2,
            }}
            key={key}
          >
            <Text
              mukta
              fontType="content2"
              style={{ color: "rgba(0, 0, 0, 0.36)", marginBottom: 4 }}
            >
              {value ? labelText : ""}
            </Text>
            <InputBox
              inputStyle={{
                backgroundColor: "#f7f7f7",
              }}
              password={key === "no"}
              placeholder={placeholder}
              value={value}
              maxLength={maxLength || null}
              onChange={(text) => {
                setAccountNameError(null);
                setAccountNoError(null);
                setIfscError(null);
                setConfirmAccountError(null);
                onChange(text);
                if (validator) {
                  validator(text);
                }
              }}
              borderRadius={6}
              keyboardType={keyboardType}
              error={error !== null}
              errorMessage={error}
              labelTextColor="rgba(0, 0, 0, 0.36)"
              disabled={false}
            />
            {key === "ifsc" && ifscLoading && (
              <ActivityIndicator
                style={{
                  color: colors.internationalOrange,
                  marginBottom: 0,
                  position: "absolute",
                  right: 12,
                  top: 36,
                }}
                size="small"
                color={colors.primary}
              />
            )}
            {key === "ifsc" && ifscDetails === false && !ifscLoading && (
              <Text
                style={{
                  color: colors.errorRed,
                  marginBottom: 0,
                  position: "absolute",
                  right: 12,
                  top: 36,
                }}
                disabled={false}
                fontType="content2"
              >
                {t(`${PATH}/enterAValidIFSC`)}
              </Text>
            )}
            {key === "ifsc" && ifscDetails && (
              <View
                style={{
                  marginBottom: 24,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <BankImage />
                <View
                  style={{
                    marginLeft: 8,
                  }}
                >
                  <Text
                    bold
                    mukta
                    fontType="head4"
                    style={{ color: colors.lightBlack }}
                  >
                    {ifscDetails.BANK}
                  </Text>
                  <Text
                    mukta
                    fontType="content3"
                    style={{ color: colors.lightBlack }}
                  >
                    {ifscDetails.BRANCH}
                  </Text>
                </View>
              </View>
            )}
          </View>
        );
      },
    );
  }

  const allFieldsFilled = ifsc && accountNo && accountName && confirmAccountNo;

  return (
    <View style={styles.container}>
      <KeyboardAwareScrollView
        showsVerticalScrollIndicator={false}
        style={{ flex: 1 }}
        bottomOffset={30}
      >
          {IS_UPI
            ? renderInputs([
                {
                  key: "upi",
                  placeholder: t(`${PATH}/enterUPI`),
                  labelText: "UPI id",
                  value: upi,
                  onChange: setUpi,
                  keyboardType: "default",
                  error: upiError,
                },
              ])
            : renderInputs([
                {
                  key: "no",
                  placeholder: t(`${PATH}/enterAccNo`),
                  labelText: t(`${PATH}/accNo`),
                  value: accountNo,
                  onChange: (text) => {
                    setAccountNo(text.replace(/[^0-9]/g, ""));
                  },
                  keyboardType: "number-pad",
                  error: accountNoError,
                },
                {
                  key: "no1",
                  placeholder: t(`${PATH}/cnfmAccNo`),
                  labelText: t(`${PATH}/cnfmAccNo`),
                  value: confirmAccountNo,
                  onChange: (text) => {
                    setConfirmAccountNo(text.replace(/[^0-9]/g, ""));
                  },
                  keyboardType: "number-pad",
                  error: confirmAccountError,
                },
                {
                  key: "ifsc",
                  placeholder: "IFSC",
                  labelText: "IFSC",
                  value: ifsc,
                  onChange: setIfsc,
                  maxLength: 11,
                  keyboardType: "default",
                  error: ifscError,
                  validator: validateIFSC,
                },
                {
                  key: "name",
                  placeholder: t(`${PATH}/accHolderName`),
                  labelText: t(`${PATH}/accHolderName`),
                  value: accountName,
                  onChange: (text) => {
                    setAccountName(text.replace(/[^A-Za-z _]/gi, ""));
                  },
                  keyboardType: "default",
                  error: accountNameError,
                },
              ])}
      </KeyboardAwareScrollView>
      <TouchableOpacity
        disabled={wallet.createFundAccountStatus === STATE_STATUS.CREATING}
        onPress={() => {
          createAccount();
        }}
        style={[
          styles.add_bank_button,
          {
            backgroundColor:
              wallet.createFundAccountStatus === STATE_STATUS.CREATING
                ? colors.mercury
                : allFieldsFilled
                  ? colors.primary
                  : colors.mercury,
          },
        ]}
      >
        <Text bold mukta fontType="head3" style={{ color: colors.white }}>
          {t(`${PATH}/goAhead`)}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    flex: 1,
  },
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerContainer: {
    padding: 10,
  },
  primaryHeading: {
    marginBottom: 12,
  },
  secondaryHeading: {
    color: colors.lightBlack,
  },
  add_bank_button: {
    paddingVertical: 16,
    width: "100%",
    marginVertical: 24,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },
  text: {},
});

const mstp = ({ wallet, auth: { user } }) => {
  return {
    wallet,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFundAccounts: () => dispatch(walletActions.fetchFundAccounts()),
    createFundAccountBank: (payload) =>
      dispatch(walletActions.createFundAccountBank(payload)),
    resetFundAccountBank: () => dispatch(walletActions.resetFundAccountBank()),
    failedCreateFundAccountBank: (payload) =>
      dispatch(walletActions.failedCreateFundAccountBank(payload)),
  };
};

export default connect(mstp, mapDispatchToProps)(WithdrawMoneyContent);
